import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_STORE_ID, EMP_DOMAIN, PLAY_STORE_ID } from "../../services/config";

const FirebaseActionHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");
    const oobCode = params.get("oobCode");
    const apiKey = params.get("apiKey");
    const continueUrl = params.get("continueUrl");
    const role = params.get("role");
    const email = params.get("email");
    const employeerole = params.get("employeerole");
    const ua = navigator.userAgent.toLowerCase();

    if (!mode || !oobCode) {
      navigate("/");
      return;
    }

    let continueEmail = "";
    let continueUid = "";
    try {
      if (continueUrl) {
        const cu = new URL(continueUrl);
        continueEmail = cu.searchParams.get("email") || "";
        continueUid = cu.searchParams.get("uid") || "";
      }
    } catch {
      // continueUrl may be missing or malformed
    }

    const query = new URLSearchParams({
      oobCode,
      apiKey,
      ...(role && { role }),
      ...(email && { email }),
      ...(employeerole && { employeerole }),
      ...(continueEmail && { email: continueEmail }),
      ...(continueUid && { uid: continueUid }),
    }).toString();

    let pathFromContinueUrl = "";
    try {
      const parsed = new URL(continueUrl);
      pathFromContinueUrl = parsed.pathname.toLowerCase();
    } catch {
      // continueUrl might be invalid or not provided
    }
    // if (!pathFromContinueUrl) {
    //   if (ua.includes("mac") && !/iphone|ipad|ipod/.test(ua)) {
    //     window.location.href = `https://${APP_STORE_ID}`;
    //   } else if (ua.includes("win")) {
    //     window.location.href = `https://${PLAY_STORE_ID}`;
    //   } else if (/iphone|ipad|ipod/.test(ua)) {
    //     window.location.href = `https://${APP_STORE_ID}`;
    //   } else if (/android/.test(ua)) {
    //     window.location.href = `https://${PLAY_STORE_ID}`;
    //   } else {
    //     window.location.href = `https://${EMP_DOMAIN}/updatepassword?${query}`;
    //   }
    // }

    if (pathFromContinueUrl === "/updatepassword" || mode === "resetPassword") {
        navigate(`/updatepassword?${query}`);
    } else if (pathFromContinueUrl === "/verify-email" || mode === "verifyEmail") {
      navigate(`/verify-email?${query}`);
    } else {
        window.location.href = `https://${EMP_DOMAIN}/updatepassword?${query}`;
    }
  }, [navigate]);

  return null;
};

export default FirebaseActionHandler;
